var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcon = function SvgIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape",
    transform: "translate(2.000000, 1.000000)",
    fill: "#777776",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,4 C2.44771525,4 2,4.44771525 2,5 L2,19 C2,19.5522847 2.44771525,20 3,20 L17,20 C17.5522847,20 18,19.5522847 18,19 L18,5 C18,4.44771525 17.5522847,4 17,4 L3,4 Z M3,2 L17,2 C18.6568542,2 20,3.34314575 20,5 L20,19 C20,20.6568542 18.6568542,22 17,22 L3,22 C1.34314575,22 0,20.6568542 0,19 L0,5 C0,3.34314575 1.34314575,2 3,2 Z",
    id: "Rectangle-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,10 C0.44771525,10 0,9.55228475 0,9 C0,8.44771525 0.44771525,8 1,8 L19,8 C19.5522847,8 20,8.44771525 20,9 C20,9.55228475 19.5522847,10 19,10 L1,10 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,1 C13,0.44771525 13.4477153,0 14,0 C14.5522847,0 15,0.44771525 15,1 L15,5 C15,5.55228475 14.5522847,6 14,6 C13.4477153,6 13,5.55228475 13,5 L13,1 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,1 C5,0.44771525 5.44771525,0 6,0 C6.55228475,0 7,0.44771525 7,1 L7,5 C7,5.55228475 6.55228475,6 6,6 C5.44771525,6 5,5.55228475 5,5 L5,1 Z",
    id: "Shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon.c1a330b3.svg";
export { ForwardRef as ReactComponent };